__turbopack_context__.v({
  "actions": "ConsentLayer-module__sHRQ6W__actions",
  "bar": "ConsentLayer-module__sHRQ6W__bar",
  "consent-in": "ConsentLayer-module__sHRQ6W__consent-in",
  "inner": "ConsentLayer-module__sHRQ6W__inner",
  "text": "ConsentLayer-module__sHRQ6W__text",
});
